import { render, staticRenderFns } from "./GraphModal.vue?vue&type=template&id=54bed124&"
import script from "./GraphModal.vue?vue&type=script&lang=js&"
export * from "./GraphModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CButton: require('@chakra-ui/vue').CButton, CText: require('@chakra-ui/vue').CText, CBox: require('@chakra-ui/vue').CBox, CModalHeader: require('@chakra-ui/vue').CModalHeader, CSpinner: require('@chakra-ui/vue').CSpinner, CFlex: require('@chakra-ui/vue').CFlex, CModalBody: require('@chakra-ui/vue').CModalBody, CButton: require('@chakra-ui/vue').CButton, CModalFooter: require('@chakra-ui/vue').CModalFooter, CModalContent: require('@chakra-ui/vue').CModalContent, CModalOverlay: require('@chakra-ui/vue').CModalOverlay, CModal: require('@chakra-ui/vue').CModal})
